import { App as AntdApp, ConfigProvider } from 'antd';
import { Provider } from 'jotai';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { store } from './store';
import AuthProvider from './features/auth/providers/AuthProvider';
import { GlobalStyle } from './components/layout/GlobalStyle';

function App() {
  return (
    <Provider store={store}>
      {/* cssVar を有効化し AntD の design token を CSS 変数(--ant-*)として公開する。
          ヘッダのハイライト等、styled-components 側からテーマ追従の色を参照できるようにするため。 */}
      <ConfigProvider theme={{ cssVar: true }}>
        <AntdApp>
          <GlobalStyle />
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
